export {
  HeadingColor,
  HeadingComponent,
  HeadingType,
  HeadingWeight,
} from './heading.component';
